export const CITIZENSHIP_STATUS = {
    NO: 'No',
    BORN_IN_CANADA: 'BornInCanada',
    BY_DESCENT: 'BornOutsideCanada', // Represents Citizenship by Descent
    NATURALIZED: 'Naturalized',
};

export const CITIZENSHIP_LABELS = {
    [CITIZENSHIP_STATUS.NO]: 'No',
    [CITIZENSHIP_STATUS.BORN_IN_CANADA]: 'Yes (Born in Canada)',
    [CITIZENSHIP_STATUS.BY_DESCENT]: 'Yes (By Descent, Recognized Prior to December 15, 2025)',
    [CITIZENSHIP_STATUS.NATURALIZED]: 'Yes (Naturalized)',
};